export enum BatchStates {
  VIEW = 1,
  EDIT
}
